import { BsPlusSquare } from "react-icons/bs";
import { GoPlus } from "react-icons/go";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import { IoIosArrowDown } from "react-icons/io";
import { IoFilterOutline } from "react-icons/io5";

import { SearchOutlined } from "@ant-design/icons";
import { Button, Dropdown, Input, Menu, MenuProps, Modal, Popover } from "antd";
import { Key, useState } from "react";
import PopAddNewClientAdmin from "../../clients/PopAddNewClientAdmin";
import AddTeamMember from "../../teamMember/creatTeamMember/AddTeamMember";
import BlogForm from "../AdminBlog/BlogForm";
import ModalAdminCategory from "../AdminCategory/ModalAdminCategory";
import ConfirmModal from "./ConfirmModal";
import FilterForm from "./FilterForm";
import SalonModal from "./SalonModal";
import { useParams } from "react-router-dom";

type Props = {
  selectedRowKeys?: Key[];
  labelButton?: string;
  modalId: number;
  hasModal?: boolean;
  isDropDown?: boolean;
  setIsFilter?: any;
  data?: any;
  filterType: any;
  actionItems?: any;
  requestStatus?: any;
  requestDelete?: any;
  confirmMessage: any;
  setConfirmMessage: any;
  closeModalConfirm: any;
  isModalConfirmOpen: any;
  showModalConfirm: any;
  setSearchHeader: any;
  placeholderSearch: string;
  searchHeader: any;
};

const HeaderTableSuperAdmin = ({
  selectedRowKeys,
  labelButton,
  modalId,
  hasModal = true,
  isDropDown = false,
  data,
  setIsFilter,
  filterType,
  requestStatus,
  requestDelete,
  confirmMessage,
  setConfirmMessage,
  closeModalConfirm,
  isModalConfirmOpen,
  showModalConfirm,
  setSearchHeader,
  placeholderSearch,
  searchHeader,
  actionItems = [],
}: Props) => {
  const params = useParams();
  const [modal, setModal] = useState(false);
  const [salonType, setSalonType] = useState("");
  const [open, setOpen] = useState(false);
  const closeModal = () => {
    setModal(false);
  };
  const openModal = (type: any) => {
    setModal(true);
    setSalonType(type);
  };

  const items: MenuProps["items"] = [
    {
      label: (
        <div
          onClick={() => openModal("Salon")}
          className="text-[#75757E] text-sm font-normal flex items-center gap-2"
        >
          <GoPlus className="text-base text-color-primary" />
          <span>Salon</span>
        </div>
      ),
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: (
        <div
          onClick={() => openModal("Freelnacer")}
          className="text-[#75757E] text-sm font-normal flex items-center gap-2"
        >
          <GoPlus className="text-base text-color-primary" />
          <span>Freelnacer</span>
        </div>
      ),
      key: "1",
    },
  ];

  const menuItems = (
    <Menu className="!py-4 !px-5 min-w-[220px]">
      <Menu.Item className="!p-0 !mb-4">
        <div className="flex items-center gap-1">
          <span className="text-sm font-normal !text-[#75757E]">Selected</span>
          <span className="text-sm font-semibold text-color-primary">
            ({selectedRowKeys?.length})
          </span>
        </div>
      </Menu.Item>
      {actionItems?.map((item: any, index: any) => (
        <>
          <Menu.Item
            key={index}
            className="!p-0 "
            onClick={() =>
              showModalConfirm(
                item?.title,
                item?.description,
                item?.status,
                item?.color
              )
            }
          >
            <span
              style={{ color: item?.color }}
              className={`text-sm font-normal`}
            >
              {item.text}
            </span>
          </Menu.Item>
          {index < actionItems.length - 1 && <Menu.Divider className="!my-3" />}
        </>
      ))}
    </Menu>
  );

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };
  const modals = [
    <AddTeamMember
      visible={modal}
      onClose={closeModal}
      config={{
        isAdmin: true,
        locationId: +params?.salonName!,
        locationName: data?.name,
        isEdit: false,
        salonId: data?.salonId,
      }}
    />,
    <SalonModal modal={modal} closeModal={closeModal} type={salonType} />,
    <Modal
      width="60%"
      open={modal}
      onCancel={closeModal}
      className="max-md:min-w-[95%] max-lg:min-w-[80%]"
      footer={null}
      destroyOnClose
    >
      <PopAddNewClientAdmin close={closeModal} />
    </Modal>,
    <Modal
      width="70%"
      open={modal}
      centered
      onCancel={closeModal}
      className="max-md:min-w-[95%] max-lg:min-w-[80%] min-w-[600px]"
      footer={null}
      destroyOnClose
    >
      <BlogForm close={closeModal} />
    </Modal>,
    <Modal
      width="40%"
      open={modal}
      centered
      onCancel={closeModal}
      className="max-md:min-w-[95%] max-lg:min-w-[80%] min-w-[600px]"
      footer={null}
      destroyOnClose
    >
      <ModalAdminCategory close={closeModal} />
    </Modal>,
  ];
  return (
    <>
      <Modal
        width="40%"
        open={isModalConfirmOpen}
        centered
        onCancel={closeModalConfirm}
        className="max-md:min-w-[95%] max-lg:min-w-[80%] min-w-[600px]"
        footer={null}
        destroyOnClose
      >
        <ConfirmModal
          invalidateQueries="AdminLocations"
          LocationId={selectedRowKeys}
          title={confirmMessage?.title}
          para={confirmMessage?.para}
          status={confirmMessage?.status}
          closeModal={closeModalConfirm}
          color={confirmMessage?.color}
          requestStatus={requestStatus}
          requestDelete={requestDelete}
        />
      </Modal>
      {modal && modals[modalId]}
      <div className="flex items-center gap-4 admin">
        <Popover
          content={
            <FilterForm
              setIsFilter={setIsFilter}
              filterType={filterType}
              setOpen={setOpen}
            />
          }
          title={false}
          trigger="click"
          open={open}
          onOpenChange={handleOpenChange}
          placement="bottom"
        >
          <Button className="flex items-center justify-center p-2 px-3 bg-white rounded-lg">
            <IoFilterOutline className="text-xl text-color-primary" />
          </Button>
        </Popover>
        {actionItems.length > 0 && (
          <Dropdown trigger={["click"]} overlay={menuItems} placement="bottom">
            <Button className="flex items-center justify-center p-2 px-3 bg-white rounded-lg">
              <HiOutlineDotsHorizontal className="text-xl text-color-primary" />
            </Button>
          </Dropdown>
        )}
        <Input
          size="small"
          placeholder={placeholderSearch}
          className="w-full h-full px-4 py-2 rounded-lg"
          value={searchHeader}
          onChange={(e) => setSearchHeader(e.target.value)}
          prefix={<SearchOutlined className="text-[#B0B0C0] mr-2" />}
          style={{ paddingRight: 30 }} // Increase paddingRight to accommodate the icon
        />
        {hasModal ? (
          <Button
            type="primary"
            icon={<BsPlusSquare size={15} />}
            onClick={openModal}
          >
            {labelButton}
          </Button>
        ) : null}
        {isDropDown ? (
          <Dropdown menu={{ items }} trigger={["click"]}>
            <Button
              className=""
              type="primary"
              icon={<BsPlusSquare size={15} />}
            >
              <div className="flex items-center gap-2">
                <span className="">{labelButton}</span>
                <IoIosArrowDown />
              </div>
            </Button>
          </Dropdown>
        ) : null}
      </div>
    </>
  );
};

export default HeaderTableSuperAdmin;
